<template>
  <div v-loading.fullscreen.lock="loading">
    <el-transfer
      style="text-align: left; display: inline-block"
      :titles="titles"
      :data="activeCustomers"
      v-model="selected"
      filterable
      filter-placeholder="Enter Company"
      @change="emitSelectedAccounts"
    >
      <span slot-scope="{ option }">
        {{ option.label }}
      </span>
      <el-select v-model="type" slot="left-footer" label="Type" size="large">
        <el-option value="Active"></el-option>
        <el-option value="Pending"></el-option>
        <el-option value="Lien"></el-option>
        <el-option value="Pre_Lien" label="Pre Lien"></el-option>
        <el-option value="Late"></el-option>
        <el-option value="Moving_Out"></el-option>
        <el-option value="PastDueNoACH" label="Past Due No ACH"></el-option>
      </el-select>

      <div slot="right-footer" class="message">
        Selected customers: <el-tag hit>{{ selected.length }}</el-tag>
      </div>
    </el-transfer>
  </div>
</template>

<script>
import axios from 'axios';
import { UNITS_API_BASE, CUSTOMER_API_BASE, ADMIN_API_BASE } from '../env';
import { getActiveCustomers } from '../utils/commonApi';

export default {
  name: 'EmailRecipients',
  props: { facility: { type: String, required: true } },
  watch: {
    async facility() {
      this.loading = true;
      const activeCustomers = await getActiveCustomers(
        this.facility, { token: this.$keycloak.token, type: this.type },
      );
      this.activeCustomers = activeCustomers.map(
        customer => ({ key: customer._id, label: customer.company || 'No Name' }),
      ).sort((a, b) => a.label.localeCompare(b.label));
      this.loading = false;
    },
    async type() {
      this.loading = true;

      if (this.type === 'PastDueNoACH') {
        const NET_PAST_DUE_THRESHOLD = 100;
        try {
          const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}/collections`, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
            params: {
              leaseTypes: 'active',
            },
          });
          const collections = response.data.result || [];

          this.activeCustomers = collections
            .filter((collection) => {
              const netPastDue = (collection.totalAR || 0) - (collection.achTransaction || 0);
              return netPastDue >= NET_PAST_DUE_THRESHOLD;
            })
            .map(collection => ({
              key: collection.member ? collection.member._id : '',
              label: collection.member ? collection.member.company : 'No Name',
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
        } catch (error) {
          this.$message.error({
            message: 'Error fetching customers for Past Due No ACH',
          });
          this.activeCustomers = [];
        } finally {
          this.loading = false;
        }
        return;
      }

      if (this.type === 'Moving_Out') {
        const response = await axios.get(`${UNITS_API_BASE}/${this.facility}`, {
          params: {
            status: 'MOVING_OUT',
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        const unitsData = response.data;

        const customerIds = unitsData.map(unit => unit.customer).filter((item) => {
          if (item) {
            return item;
          }
        });

        if (customerIds.length > 0) {
          const customerResponse = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/get/all`, {
            params: {
              customers: [...customerIds].toString(),
            },
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          this.activeCustomers = customerResponse.data.map(customer => ({ key: customer._id, label: customer.company || 'No Name' }))
            .sort((a, b) => a.label.localeCompare(b.label));
        } else {
          this.activeCustomers = [];
        }

        this.loading = false;
        return;
      }
      const activeCustomers = await getActiveCustomers(
        this.facility,
        { token: this.$keycloak.token, type: this.type },
      );
      this.activeCustomers = activeCustomers.map(
        customer => ({ key: customer._id, label: customer.company || 'No Name' }),
      ).sort((a, b) => a.label.localeCompare(b.label));
      this.loading = false;
    },
  },
  computed: {
    titles() {
      return [`${this.type} Customers`, 'Email Recepients'];
    },
  },
  data() {
    return {
      activeCustomers: [],
      selected: [],
      type: 'Active',
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    const activeCustomers = await getActiveCustomers(
      this.facility, { token: this.$keycloak.token, type: this.type },
    );
    this.activeCustomers = activeCustomers.map(
      customer => ({ key: customer._id, label: customer.company || 'No Name' }),
    ).sort((a, b) => a.label.localeCompare(b.label));
    this.loading = false;
    console.log(this.activeCustomers);
  },
  methods: {
    emitSelectedAccounts() {
      this.$emit('change', this.selected);
    },
  },
};
</script>

<style scoped>
.message {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailRecipients.vue